<template>
  <v-card class="pa-4">
    <div class="d-flex justify-end">
      <v-btn class="mb-4 mr-2" color="green" dark outlined @click="() => $refs['popup-import'].openDialog()">
        Nhập/xuất Excel giáo viên
      </v-btn>
      <v-btn color="primary" @click="() => $refs['popup-add-teachers'].openDialog()">
        <v-icon left>add</v-icon> Thêm giáo viên
      </v-btn>
    </div>
    <TeacherTable class="mt-4" />
    <PopupImport ref="popup-import" />
    <PopupAddTeachers ref="popup-add-teachers" />
  </v-card>
</template>
<script>
import PopupAddTeachers from './PopupAddTeachers.vue'
import PopupImport from './PopupImport.vue'
import TeacherTable from './TeacherTable.vue'

export default {
  components: { TeacherTable, PopupImport, PopupAddTeachers },
}
</script>